import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="max-w-md w-full border border-[rgba(10,10,10,0.10)] bg-[#FAF5E6] p-10">
        <div className="font-mono uppercase tracking-[0.25em] text-xs text-[#525252]">Reset password</div>
        <h1 className="font-heading text-4xl text-[#0A0A0A] mt-3">Forgot it.</h1>
        <p className="text-sm text-[#525252] mt-3">Type the email on your account and we'll send you a link to choose a new one.</p>
        {sent ? (
          <div className="mt-8 border-l-2 border-[#0A0A0A] pl-4" data-testid="forgot-sent">
            <p className="text-sm text-[#0A0A0A]">If an account exists for <strong>{email}</strong>, a reset link is on its way. The link expires in one hour.</p>
            <Link to="/login" className="font-mono uppercase tracking-widest text-xs text-[#0A0A0A] hover:underline mt-4 inline-block">← Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="font-mono uppercase tracking-widest text-[10px] text-[#525252]">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 bg-white border border-[rgba(10,10,10,0.12)] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-black"
                data-testid="forgot-email-input"
                placeholder="you@example.com"
              />
            </div>
            <button
              type="submit"
              disabled={busy || !email}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0A0A0A] hover:bg-[#1F1F1F] text-[#F2EAD3] font-mono uppercase tracking-widest text-xs px-4 py-3 rounded-sm transition-colors disabled:opacity-50"
              data-testid="forgot-submit"
            >
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Send reset link"}
            </button>
            <Link to="/login" className="font-mono uppercase tracking-widest text-xs text-[#525252] hover:text-[#0A0A0A] inline-block">← Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
